
export enum DirectoryAssistance {
    No,
    PhoneOnly,
    Yes,
}